import { Color } from '@persona-id/design-tokens';
import { MutableRefObject, useEffect, useRef } from 'react';
import styled from 'styled-components';

import EventBus from 'dashboard/components/GraphCanvasV2/event-bus';
import G6Wrapper from 'dashboard/components/GraphCanvasV2/G6Wrapper';
import MinimapPlugin from 'dashboard/components/GraphCanvasV2/plugins/minimap-plugin';
import { Elevation } from 'design-system/variables/effect';

const Container = styled.div<{
  width: number;
  height: number;
  left: number;
  bottom: number;
}>`
  position: absolute;
  ${({ width, height, left, bottom }) => {
    return `
        width: ${width}px;
        height: ${height}px;
        left: ${left}px;
        bottom: ${bottom}px;
      `;
  }}

  border: 3px solid ${Color.PrimaryWhite};
  &:after {
  }

  border-radius: 8px;
  box-shadow: ${Elevation.Low};
  background: ${Color.CoreSlate50};
  overflow: hidden;
  opacity: 1;
  transition: opacity 0.25s ease-in-out;

  &:hover {
    opacity: 0;
  }
`;

const Viewport = styled.div`
  position: absolute;
  box-sizing: border-box;
  outline: 1px solid ${Color.CorePurple600};
`;

interface GraphCanvasMinimapProps {
  eventBus: EventBus;
  g6Wrapper: G6Wrapper;
  minimapRef?: MutableRefObject<HTMLDivElement>;
}

const GraphCanvasMinimap = ({ eventBus, g6Wrapper, minimapRef }: GraphCanvasMinimapProps) => {
  const minimapElRef = useRef<HTMLDivElement>();
  const minimapPlugin = useRef<MinimapPlugin>(new MinimapPlugin(g6Wrapper, eventBus)).current;
  const minimapViewportRef = useRef<HTMLDivElement>();

  // Clean up minimap plugin on unmount
  useEffect(() => {
    return () => {
      if (minimapPlugin) {
        minimapPlugin.destroy();
      }
    };
  }, []);

  // These are some magic positioning numbers that seem to work
  const height = 240;
  const width = 300;
  const left = 16;
  const bottom = 16;

  if (!g6Wrapper || !g6Wrapper.graph) {
    return null;
  }

  return (
    <Container
      data-graph-target='graph-minimap'
      width={width}
      height={height}
      left={left}
      bottom={bottom}
      id='minimap'
      ref={(el) => {
        if (!minimapPlugin.bound) {
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          minimapPlugin.bindToContainer(el);
        }

        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        minimapElRef.current = el;
        if (minimapRef) {
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          minimapRef.current = el;
        }
      }}
    >
      <Viewport
        ref={(el) => {
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          minimapViewportRef.current = el;
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          minimapPlugin.bindViewportToContainer(el);
        }}
      />
    </Container>
  );
};

export default GraphCanvasMinimap;
